import { render, staticRenderFns } from "./Alta.vue?vue&type=template&id=459382e1&"
import script from "./Alta.vue?vue&type=script&lang=js&"
export * from "./Alta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports